/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleListStats
 */
export interface VehicleListStats {
    /**
     * 
     * @type {number}
     * @memberof VehicleListStats
     */
    totalOperatingSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleListStats
     */
    totalLoginSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleListStats
     */
    totalDriveSeconds: number;
}

/**
 * Check if a given object implements the VehicleListStats interface.
 */
export function instanceOfVehicleListStats(value: object): value is VehicleListStats {
    if (!('totalOperatingSeconds' in value) || value['totalOperatingSeconds'] === undefined) return false;
    if (!('totalLoginSeconds' in value) || value['totalLoginSeconds'] === undefined) return false;
    if (!('totalDriveSeconds' in value) || value['totalDriveSeconds'] === undefined) return false;
    return true;
}

export function VehicleListStatsFromJSON(json: any): VehicleListStats {
    return VehicleListStatsFromJSONTyped(json, false);
}

export function VehicleListStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleListStats {
    if (json == null) {
        return json;
    }
    return {
        
        'totalOperatingSeconds': json['totalOperatingSeconds'],
        'totalLoginSeconds': json['totalLoginSeconds'],
        'totalDriveSeconds': json['totalDriveSeconds'],
    };
}

export function VehicleListStatsToJSON(json: any): VehicleListStats {
    return VehicleListStatsToJSONTyped(json, false);
}

export function VehicleListStatsToJSONTyped(value?: VehicleListStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalOperatingSeconds': value['totalOperatingSeconds'],
        'totalLoginSeconds': value['totalLoginSeconds'],
        'totalDriveSeconds': value['totalDriveSeconds'],
    };
}

